import { createContext, useContext } from 'react';

import { useAuth } from '@/features/auth/authContext';

export interface OperatorShiftState {
  /** "Log out": an operator with an open shift is offered to close it first. */
  requestLogout: () => void;
}

export const OperatorShiftContext = createContext<OperatorShiftState | null>(null);

/** What the "Log out" item calls. Outside the gate it simply logs out. */
export function useLogoutRequest(): () => void {
  const state = useContext(OperatorShiftContext);
  const { logout } = useAuth();
  return state?.requestLogout ?? (() => void logout());
}
